import React from 'react';
import RestShow from 'containers/rest/Show';
import RestFieldItem from 'components/RestField/RestFieldItem';

const WorkTypesShow = (props) => (
  <RestShow {...props} hasEdit resource="workingTypes">
    <RestFieldItem source="name" header="workingTypes.name" />
    <RestFieldItem source="description" header="workingTypes.description" />
    <RestFieldItem source="priority" header="workingTypes.priority" />
    <RestFieldItem source="isActive" header="workingTypes.isActive" />
  </RestShow>
);

export default WorkTypesShow;
